import script from "./GeneratePortfolioAdvanced.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratePortfolioAdvanced.vue?vue&type=script&setup=true&lang=js"

import "./GeneratePortfolioAdvanced.vue?vue&type=style&index=0&id=7fb7054d&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb7054d"]])

export default __exports__